import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Create
} from "adminApi/AboutUsApi/AboutUs.js";
import { validateForm } from "utils/validation";
import { AboutUsRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/AboutUsField.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import AddAboutUsForm from "./Components/AddAboutUsForm";

const AddAboutUs = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(initialValues, AboutUsRules);

    // Form submit hook
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => {
                if (key === "stats_icons" || key === "values_icons") {
                    // Handle multiple file uploads
                    if (val && Array.isArray(val)) {
                        val.forEach((file, index) => {
                            formData.append(`${key}`, file);
                        });
                    }
                } else if (key === "story_image") {
                    // Handle single file upload
                    if (val) formData.append(key, val);
                } else if (key === "stats" || key === "values_list") {
                    // Keep JSON as string
                    formData.append(key, val ?? "");
                } else {
                    formData.append(key, val ?? "");
                }
            });
            return await Create({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, AboutUsRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "About Us Created successfully"
    );
    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddAboutUsForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                handleFileChange={handleFileChange}
                imagePreview={values.story_imagePreview || values.story_image}
            />
        </>
    );
};

export default AddAboutUs;
